// Initialisation de l'objet queryParams pour stocker les paramètres de requête
Shopify.queryParams = {};

function refreshCollectionPageWithFilters(url_filters) {
  let currentUrl = '//' + location.host + location.pathname;
  let newPageString = httpGet(`${currentUrl}?${url_filters}&section_id=${returnShopifySectionIdShort()}`);
  
  let newPageEl = document.createElement('DIV');
  newPageEl.innerHTML = newPageString;

  let newSection = newPageEl.querySelector(".mm-grid-second-container");
  let activeFilters = newPageEl.querySelectorAll(".active-filters");

  document.querySelector(".mm-grid-second-container").innerHTML = newSection.innerHTML;

  activeFilters.forEach(function (activeFilter) {
    let newActiveFilters = document.querySelectorAll(".active-filters");
    newActiveFilters.forEach(function (newActiveFilter) {
      newActiveFilter.innerHTML = activeFilter.innerHTML;
    });
  });

  // Nb of products hero
  const nb_of_products = document.querySelector('.mm-grid-card-collection').dataset.nbProducts;
  const nb_of_products_info_banner = document.querySelector('.mm-hero-collection-size span');
  if (nb_of_products_info_banner) {
    nb_of_products_info_banner.innerText = nb_of_products;
  }

  // Nb of products CTA
  const CTA = document.querySelector('.mm-filter-cta-btn');
  const newCTA = newPageEl.querySelector(".mm-filter-cta-btn");
  CTA.innerHTML = newCTA.innerHTML;

  // Mise à jour de l'URL dans l'historique sans recharger la page
  window.history.replaceState(null, document.title, currentUrl + '?' + url_filters);
  document.querySelector('.mm-grid-second-container').classList.remove('mm-loading-filter');
  
  // Réinitialiser les vidéos
  initializeVideos();

  // Vérifie les changements dans les filtres après le rafraîchissement
  checkForChanges();
}

/*********************************************************************************************
 * Return the Shopify section ID of the collection grid.
 * 
 * @returns {string} - The section ID of the grid.
 */
function returnShopifySectionId() {
  const gridElem = document.querySelector('.mm-grid-collection');
  const gridSection = gridElem.closest('.shopify-section');
  return gridSection.id;
}

/*********************************************************************************************
 * Return the Shopify section ID without the 'shopify-section-' prefix.
 * 
 * @returns {string} - The shortened section ID.
 */
function returnShopifySectionIdShort() {
  return returnShopifySectionId().replace('shopify-section-', '');
}

/*********************************************************************************************
 * Perform a synchronous GET request.
 * 
 * @param {string} theUrl - The URL to request.
 * @returns {string} - The response text from the request.
 */
function httpGet(theUrl) {
  var xmlHttp = new XMLHttpRequest();
  xmlHttp.open('GET', theUrl, false);  // Synchronous request
  xmlHttp.send(null);
  return xmlHttp.responseText;
}

/*********************************************************************************************
 * Check for changes in the filter inputs and submit the form if changes are detected.
 */
function checkForChanges() {
  var form = document.getElementById('collectionFacetsForm');
  var inputs = form.querySelectorAll('input');

  // Ajouter un listener sur chaque input pour détecter les changements
  inputs.forEach(function (input) {
    input.addEventListener('change', function () {
      setTimeout(() => {
        fakeSubmitForm();
      }, "10");
    });
  });
}

// Exécuter checkForChanges après le chargement de la page
window.addEventListener('DOMContentLoaded', (event) => {
  checkForChanges();
});

/*********************************************************************************************
 * Serialize the form data and refresh the collection page with the filters.
 */
function fakeSubmitForm() {
  let form = document.getElementById("collectionFacetsForm");
  let url_filters = new URLSearchParams(new FormData(form)).toString();
  document.querySelector('.mm-grid-card-collection').classList.add('mm-loading-filter');
  
  // Rafraîchir la collection avec les filtres
  setTimeout(() => {
    refreshCollectionPageWithFilters(url_filters);
  }, "0");
}

window.addEventListener("DOMContentLoaded", (event) => {
  if (window.innerWidth < 900) {
    mmCheckDrawer();
  }
  mmInitSplide();
});

/*********************************************************************************************
 * Show background filter.
 */
function showBgFilter() {
  const filter = document.querySelector('.mm-filter-mega-menu');
  filter.style.zIndex = 98000;
  filter.classList.add('active');
}

/*********************************************************************************************
 * Hide background filter.
 */
function hideBgFilter() {
  const filter = document.querySelector('.mm-filter-mega-menu');
  filter.style.removeProperty('z-index');
  filter.classList.remove('active');
}

/*********************************************************************************************
 * Mobile filter drawer functions for screens smaller than 768px.
 */
if (window.innerWidth < 768) {
  function mmOpenFiltersMobile() {
    var wrapperMobile = document.querySelector('.mm-grid-first-container');
    wrapperMobile.classList.add('mm-open');
    document.querySelector('html').classList.add('stop-scrolling');  // Empêche le scroll en arrière-plan
    setTimeout(() => {
      showBgFilter();
    }, 300);
  }

  function mmCloseFiltersMobile() {
    hideBgFilter();
    var wrapperMobile = document.querySelector('.mm-grid-first-container');
    wrapperMobile.classList.remove('mm-open');
    document.querySelector('html').classList.remove('stop-scrolling');  // Réactive le scroll
  }

  function mmCheckDrawer() {
    var currentUrl = document.location.href.indexOf('?open_filters');
    if (currentUrl !== -1) {
      mmOpenFiltersMobile();
    }
  }
}

function toggleClickEvents() {
  if (window.innerWidth >= 768) {
    document.querySelectorAll('.mm-cf-tag-filter-header').forEach(function (element) {
      element.addEventListener('click', toggleClass);
    });
  } else {
    document.querySelectorAll('.mm-cf-tag-filter-header').forEach(function (element) {
      element.removeEventListener('click', toggleClass);
      element.classList.remove('mm-close'); // Retirer la classe si la fenêtre est petite
    });
  }
}

function toggleClass() {
  this.classList.toggle('mm-close');
}

// Vérifier au chargement initial
toggleClickEvents();

// Adapter lors du redimensionnement de la fenêtre
window.addEventListener('resize', toggleClickEvents);

/*********************************************************************************************
 * Fonction pour mettre à jour le compteur des filtres actifs
 */
function updateActiveFilterCount() {
  const filterContainer = document.querySelector('.mm-collection-filter');
  const checkboxes = document.querySelectorAll('#collectionFacetsForm input[type="checkbox"]');
  let activeCount = 0;

  checkboxes.forEach(checkbox => {
    if (checkbox.checked) {
      activeCount++;
    }
  });

  if (filterContainer) {
    filterContainer.setAttribute('data-active-filter-count', activeCount);
  }

  const filterNameElement = document.getElementById('filter-name');
  if (filterNameElement) {
    filterNameElement.textContent = filterNameElement.textContent.replace(/\d+/, activeCount);
  }
}

function initFilterChangeListener() {
  const checkboxes = document.querySelectorAll('#collectionFacetsForm input[type="checkbox"]');
  
  checkboxes.forEach(checkbox => {
    checkbox.addEventListener('change', updateActiveFilterCount);
  });

  updateActiveFilterCount();
}

window.addEventListener('DOMContentLoaded', (event) => {
  initFilterChangeListener();
});

/*********************************************************************************************
 * Video
 */
function initializeVideos() {
  const videoContainers = document.querySelectorAll("[data-loop-video]");

  videoContainers.forEach((container) => {
    const video = container.querySelector(".mm-braking-block-media-media");
    const playButton = container.querySelector(".play-button");
    const muteButton = container.querySelector(".mute-button");

    if (!video || !playButton || !muteButton) return;

    video.muted = false;
    playButton.classList.remove("playing");
    playButton.classList.add("paused");

    function preloadVideo(videoElement) {
      if (!videoElement) return;

      videoElement.muted = true;
      videoElement.addEventListener(
        "canplaythrough",
        () => {
          videoElement.muted = false;
          muteButton.classList.add("muted");
        },
        { once: true }
      );

      videoElement.load();
    }

    function updatePlayPauseButton() {
      if (video.paused) {
        playButton.classList.remove("playing");
        playButton.classList.add("paused");
      } else {
        playButton.classList.remove("paused");
        playButton.classList.add("playing");
      }
    }

    function updateMuteButton() {
      if (video.muted) {
        muteButton.classList.remove("muted");
        muteButton.classList.add("unmuted");
      } else {
        muteButton.classList.remove("unmuted");
        muteButton.classList.add("muted");
      }
    }

    playButton.addEventListener("click", function () {
      if (video.paused) {
        video.play();
      } else {
        video.pause();
      }
      updatePlayPauseButton();
    });

    muteButton.addEventListener("click", function () {
      video.muted = !video.muted;
      updateMuteButton();
    });

    video.addEventListener("click", function () {
      if (video.paused) {
        video.play();
      } else {
        video.pause();
      }
      updatePlayPauseButton();
    });

    preloadVideo(video);
  });
}

window.addEventListener('DOMContentLoaded', (event) => {
  initializeVideos();
});
